export default import.meta.ROLLDOWN_FILE_URL_L6ULre43UVKB_8BlqbEXWQ